// src/App.js
import { onAuthStateChanged, signOut } from "firebase/auth";
import { collection, onSnapshot, query } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import ProductList from "./components/ProductList";
import { Signup } from "./Signup";
import { auth, db } from "./firebase";
import { ListList } from "./components/ListList";
import { TopNavButtons } from "./components/TopNavButtons";

function App() {
  const [user, setUser] = useState(null);
  const [lists, setLists] = useState([]);
  const [selectedList, setSelectedList] = useState(lists[lists.length - 1]);

  useEffect(() => {
    setSelectedList(lists[lists.length - 1]);
  }, [lists]);

  const [changeListModalOpen, setChangeListModalOpen] = useState(false);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribeAuth();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      alert("Signed out successfully!");
    } catch (error) {
      console.error("Error signing out:", error.message);
      alert(`Sign out failed: ${error.message}`);
    }
  };

  useEffect(() => {
    if (user) {
      const listsCollectionRef = collection(db, "lists");
      const q = query(listsCollectionRef);

      const unsubscribeLists = onSnapshot(
        q,
        (querySnapshot) => {
          const fetchedLists = querySnapshot.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }));
          setLists(fetchedLists);
        },
        (error) => {
          console.error("Error fetching lists:", error);
          alert("Failed to load lists.");
        },
      );

      return () => {
        unsubscribeLists();
      };
    }
  }, [user]);

  if (!user) {
    return <Signup />;
  }

  if (!selectedList || changeListModalOpen) {
    return (
      <ListList
        lists={lists}
        selectedList={selectedList}
        setList={setSelectedList}
        onClose={() => setChangeListModalOpen(false)}
      />
    );
  }

  return (
    <div
      style={{
        padding: "20px",
        gap: 20,
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TopNavButtons
        handleSignOut={handleSignOut}
        openChangeListModal={() => setChangeListModalOpen(true)}
      />

      <ProductList selectedList={selectedList} />
    </div>
  );
}

export default App;
